import * as R from 'ramda';

/**
 * Important: errors thrown here are surfaced to the user, so make sure they're pretty.
 */

/**
 * @prop {Function} renameWith
 * @returns {(file: object) => object}
 */
export const renameFilestackFileWith = R.curry((renameWith, file) => {
    if (R.isNil(file)) {
        throw new Error(
            'Something went wrong uploading the file provided. Please try again. If the problem persists, please contact support.'
        );
    }

    const originalExtension = getExtension(file);

    return {
        ...file,
        name: `${renameWith()}.${originalExtension}`
    };
});

function getExtension(file) {
    if (R.isNil(file.filename)) {
        throw new Error(
            'Something went wrong preparing that file for upload. Please rename the file and try again.'
        );
    }

    if (!R.test(/\./, file.filename)) {
        throw new Error(
            'Unable to discern the file extension for the file provided. Please check the filename and try again.'
        );
    }

    try {
        return R.pipe(R.prop('filename'), R.split('.'), R.last)(file);
    } catch (error) {
        throw new Error(
            'Something went wrong preparing that file for upload. Please rename the file and try again.'
        );
    }
}



// WEBPACK FOOTER //
// ./filestack_file_utils.js